module.exports = __webpack_public_path__ + "static/media/13.a84bcc70.png";